/*
Bandeau d'accueil animé.

Ghost n'accepte que des images dans Réglages → Marque → Couverture, mais le champ
permet aussi de coller une URL : si elle pointe vers un fichier vidéo, on remplace
l'image de fond par une boucle muette. Une couverture ordinaire (y compris un GIF
ou un WebP animé, que Ghost sert sans retraitement) ne passe jamais par ici.
*/
function headerVideo() {
    const image = document.querySelector('.gh-header-image');
    const source = image?.getAttribute('src') || '';

    if (!/\.(mp4|webm|ogv)(\?.*)?$/i.test(source)) return;

    const video = document.createElement('video');

    video.className = image.className;
    video.src = source;
    video.loop = true;
    video.playsInline = true;

    /* La propriété seule ne suffit pas à Safari, qui lit l'attribut pour
       autoriser la lecture automatique. */
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    /* Le fond est décoratif : le titre et le formulaire portent le sens. */
    video.setAttribute('aria-hidden', 'true');
    video.setAttribute('tabindex', '-1');

    /* Mouvement réduit : on affiche la première image, sans l'animer. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.preload = 'metadata';
    } else {
        video.autoplay = true;
        video.preload = 'auto';
    }

    image.replaceWith(video);
}
